var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNpsreser3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 28,
    viewBox: "0 0 39 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.3125 1.5V19.3757C0.3125 19.928 0.760216 20.3757 1.3125 20.3757H2.02342C2.57571 20.3757 3.02342 19.928 3.02342 19.3757V11.5926H13.9581V19.3757C13.9581 19.928 14.4058 20.3757 14.9581 20.3757H15.669C16.2213 20.3757 16.669 19.928 16.669 19.3757V3.19918V2.84723H28.1196V4.19682V8.41652H30.8363V1.84959C30.8363 1.10423 30.2186 0.5 29.4567 0.5H15.164H14.9581C14.4058 0.5 13.9581 0.947716 13.9581 1.5V9.28319H3.02342V1.5C3.02342 0.947715 2.57571 0.5 2.02342 0.5H1.3125C0.760215 0.5 0.3125 0.947716 0.3125 1.5Z",
    fill: "url(#paint0_linear_3625_22820)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1196 19.047C28.1196 19.7808 28.7278 20.3757 29.478 20.3757C30.2282 20.3757 30.8363 19.7808 30.8363 19.047V11.3333L28.1196 11.5926V19.047Z",
    fill: "url(#paint1_linear_3625_22820)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1237 25.9065L25.1237 25.9066L25.1336 25.9116C26.6949 26.7082 28.4466 27.1 30.3756 27.1C32.0344 27.1 33.5513 26.8002 34.9159 26.1889L34.9159 26.189L34.9236 26.1854C35.8937 25.7341 36.7269 25.1363 37.4153 24.3897C38.1506 23.5923 37.8199 22.4393 37.0246 21.9368C36.2359 21.4384 35.2774 21.6784 34.6908 22.2386C34.2497 22.6599 33.749 22.9944 33.1857 23.2433C32.3211 23.6253 31.3751 23.8195 30.3401 23.8195C29.1024 23.8195 28.0048 23.5636 27.0349 23.0631C26.0643 22.5405 25.3054 21.8228 24.7477 20.9047C24.1977 19.9995 23.912 18.9219 23.912 17.6498C23.912 16.3777 24.1977 15.3001 24.7477 14.3948C25.305 13.4775 26.0625 12.7721 27.0306 12.2717L27.0306 12.2718L27.0392 12.2672C28.0085 11.7461 29.1044 11.4801 30.3401 11.4801C31.3751 11.4801 32.3211 11.6742 33.1857 12.0563C33.7471 12.3044 34.247 12.6425 34.6879 13.0727C35.2729 13.6433 36.2391 13.8922 37.0345 13.3896C37.8237 12.8908 38.1582 11.7481 37.4337 10.9495L36.9893 11.3526L37.4337 10.9495C36.7404 10.1853 35.8984 9.58379 34.9159 9.14367C33.5513 8.53241 32.0344 8.23264 30.3756 8.23264C28.4466 8.23264 26.6949 8.6244 25.1336 9.42097L25.1336 9.42095L25.1301 9.42278C23.5957 10.2184 22.378 11.3252 21.4903 12.7409C20.5955 14.1681 20.1563 15.8113 20.1563 17.6498C20.1563 19.468 20.5963 21.109 21.488 22.555L21.488 22.555L21.4903 22.5587C22.377 23.9728 23.5926 25.0892 25.1237 25.9065Z",
    stroke: "url(#paint2_linear_3625_22820)",
    strokeWidth: 1.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3625_22820",
    x1: 20.2936,
    y1: -0.742235,
    x2: 30.8433,
    y2: 19.3194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3625_22820",
    x1: 20.2936,
    y1: -0.742235,
    x2: 30.8433,
    y2: 19.3194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3625_22820",
    x1: 31.8397,
    y1: 7.72843,
    x2: 43.0569,
    y2: 21.0396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpsreser3);
export default __webpack_public_path__ + "static/media/npsreser3.df08265fead1dc368eb6fe587471073d.svg";
export { ForwardRef as ReactComponent };